// init
import {AuthLoginWebbUser} from './user-accounts';

// add identity docs
export const CreateUserDocs = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credCreateUserCredential(item)
  return (result); 
}

export const SetUserDocsStatus = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credSetUserCredential(item)
  return (result); 
}

export const GetUserDocsList = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credGetUserCredentialsList(item)
  return (result);
}

export const GetUserDocsDetail = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credGetUserCredentialsDetail(item)
  return (result);
}

export const CreateTeamDocs = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credCreateTeamCredential(item)
  return (result); 
}

export const GetTeamDocsDetail = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credGetTeamCredentialsDetail(item)
  return (result);
}

export const SetTeamDocsStatus = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credSetTeamCredential(item)
  return (result); 
}

export const CheckDocsDetail = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.credCheckUserCredentialsDetail(item)
  return (result);
}

export const GetDocsTransactions = async(item) => {
  const user = await AuthLoginWebbUser();
  const result = await user.functions.trxnGetCredentialTransactions(item)
  return (result);
}
